'use strict';

require('core/components/zoom');
